import { toRaw } from 'vue'

export function deepUnref<T>(observed: T): T {
  const val = toRaw(observed)

  if (Array.isArray(val)) {
    return toRaw(val.map(deepUnref)) as T
  }

  if (val === null) return null as T

  if (typeof val === 'object' && val?.constructor === Object) {
    const entries = Object.entries(val).map(([key, val]) => [
      key,
      deepUnref(val),
    ])

    return toRaw(Object.fromEntries(entries))
  }

  return toRaw(val)
}
